<div style="cursor: pointer;
  margin-left: 20px;
  margin-top: -53px; font-size: 20px;">
  <a class="button button--primary" style="margin-bottom: 16px;" (click)="showSearchPanel()" *ngIf="!showSearch">
    <i class="material-icons button__icon">&#xE8B6;</i>
    <span class="button__text">Search</span>
  </a>
  <div class="header__title-container" matTooltip="Hide Search" (click)="showSearchPanel()" style="cursor: pointer;"
    *ngIf="showSearch">
    <i class="material-icons title-container__close">close</i>
    <span class="panel__header__title">{{'Search'| translate | async}}</span>
  </div>
</div>
<div class="search-options"
  style="min-width: 150px;width: 100%;display: flex;justify-content: space-between;flex-wrap: wrap;padding: 0 2%;"
  [ngStyle]="{ 'display': showSearch ? 'flex' : 'none' }">

  <mat-form-field class="header-form-full-width">
    <span class="label">{{'Customer'| translate | async}}</span>
    <mat-chip-list #chipList>
      <!-- Display selected customers as chips -->
      <mat-chip *ngFor="let chip of selectedCustomers" [selectable]="true" [removable]="true"
        (removed)="removeChip(chip)">
        {{ chip.Name }}
        <mat-icon matChipRemove>cancel</mat-icon>
      </mat-chip>

      <!-- Input field for autocomplete -->
      <input placeholder="{{'Select Customer'| translate | async}}" #chipInput [matAutocomplete]="auto"
        [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        (input)="filterCustomers($event.target.value)" name="customer" ngDefaultControl />
    </mat-chip-list>

    <!-- Autocomplete dropdown -->
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectCustomer($event)">
      <mat-option *ngFor="let customer of filteredCustomers" [value]="customer.Name">
        {{ customer.Name }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>

  <mat-form-field class="header-form-full-width">
    <span class="label"> {{'Family'| translate | async}}</span>
    <mat-chip-list #FamilychipList>
      <!-- Display selected families as chips -->
      <mat-chip *ngFor="let family of selectedFamilies" [selectable]="true" [removable]="true"
        (removed)="removeFamily(family)">
        {{ family.Name }}
        <mat-icon matChipRemove>cancel</mat-icon>
      </mat-chip>

      <!-- Input field for autocomplete -->
      <input placeholder="{{'Select Family'| translate | async}}" #familychipInput [matAutocomplete]="autoFamily"
        [matChipInputFor]="FamilychipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        (input)="filterFamilies($event.target.value)" name="family" ngDefaultControl />
    </mat-chip-list>

    <!-- Autocomplete dropdown -->
    <mat-autocomplete #autoFamily="matAutocomplete" (optionSelected)="selectFamily($event)">
      <mat-option *ngFor="let family of filteredFamilies" [value]="family.Name">
        {{ family.Name }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>


  <mat-form-field class="header-form-full-width">
    <span class="label"> {{'Make'| translate | async}}</span>
    <mat-chip-list #assetMakeChipList>
      <mat-chip *ngFor="let assetMake of selectedAssetMakes" [selectable]="true" [removable]="true"
        (removed)="removeAssetMake(assetMake)">
        {{ assetMake }}
        <mat-icon matChipRemove>cancel</mat-icon>
      </mat-chip>

      <input placeholder="{{'Select asset Make'| translate | async}}" #assetMakeInput [matAutocomplete]="autoAssetMake"
        [matChipInputFor]="assetMakeChipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        (matChipInputTokenEnd)="addAssetMake($event)" (input)="filterAssetMakes($event.target.value)" name="customer12"
        ngDefaultControl />
    </mat-chip-list>
    <mat-autocomplete [(ngModel)]="selectedMake" #autoAssetMake="matAutocomplete"
      (optionSelected)="selectAssetMake($event.option)">
      <mat-option [value]="assetMake.Name" *ngFor="let assetMake of filteredAssetMakes ">
        {{ assetMake.Name }}
      </mat-option>
    </mat-autocomplete>

    <mat-autocomplete #autoAssetMake="matAutocomplete">
      <mat-option *ngFor="let assetMake of filteredAssetMakes" [value]="assetMake">
        {{ assetMake.Name }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>

  <mat-form-field class="header-form-full-width">
    <span class="label"> {{'Job Site'| translate | async}}</span>
    <mat-chip-list #jobsiteChipList>
      <mat-chip *ngFor="let jobsite of selectedJobsites" [selectable]="true" [removable]="true"
        (removed)="removeJobsite(jobsite)">
        {{ jobsite.Name }}
        <mat-icon matChipRemove>cancel</mat-icon>
      </mat-chip>
      <input placeholder=" {{'Select Job Site'| translate | async}}" #jobsiteInput [matAutocomplete]="autoJobsite"
        [matChipInputFor]="jobsiteChipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        (matChipInputTokenEnd)="addJobsite($event)" (input)="filterJobsites($event.target.value)" name="customer3"
        ngDefaultControl />
    </mat-chip-list>
    <mat-autocomplete #autoJobsite="matAutocomplete" (optionSelected)="selectJobsite($event)">
      <mat-option *ngFor="let jobsite of filteredJobsites" [value]="jobsite">
        {{ jobsite.Name }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>

  <mat-form-field class="header-form-full-width">
    <span class="label"> {{'Make'| translate | async}}</span>
    <mat-chip-list #makeChipList>

      <mat-chip *ngFor="let make of selectedMakes" [selectable]="true" [removable]="true" (removed)="removeMake(make)">
        {{ make }}
        <mat-icon matChipRemove>cancel</mat-icon>
      </mat-chip>


      <input placeholder=" {{'Select Make'| translate | async}}" #makeInput [matAutocomplete]="autoMake"
        [matChipInputFor]="makeChipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        [matChipInputAddOnBlur]="true" (matChipInputTokenEnd)="addMake($event)"
        (input)="filterMakes($event.target.value)" name="customer4" ngDefaultControl />
    </mat-chip-list>

    <mat-autocomplete #autoMake="matAutocomplete" (optionSelected)="selectMake($event)">
      <mat-option *ngFor="let make of filteredMakes" [value]="make">
        {{ make.Name }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>

  <mat-form-field class="header-form-full-width">
    <span class="label"> {{'Component Type'| translate | async}}</span>

    <!-- Chip list for selected component types -->
    <mat-chip-list #componentTypeChipList>
      <!-- Loop through selected component types and display them as chips -->
      <mat-chip *ngFor="let compType of selectedComponentTypes" [selectable]="true" [removable]="true"
        (removed)="removeComponentType(compType)">
        {{ compType.Name }}
        <mat-icon matChipRemove>cancel</mat-icon>
      </mat-chip>

      <!-- Input field to filter and add component types -->
      <input placeholder="{{'Select Component Type'| translate | async}}" #componentTypeInput
        [matAutocomplete]="autoComponentType" [matChipInputFor]="componentTypeChipList"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="true"
        (matChipInputTokenEnd)="addComponentType($event)" (input)="filterComponentTypes($event.target.value)"
        name="customer6" ngDefaultControl />
    </mat-chip-list>

    <!-- Auto-complete dropdown for available component types -->
    <mat-autocomplete #autoComponentType="matAutocomplete" (optionSelected)="selectComponentType($event)">
      <mat-option *ngFor="let compType of filteredComponentTypes" [value]="compType">
        {{ compType.Name }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>


  <mat-form-field class="header-form-full-width">
    <span class="label">{{'Asset Types'| translate | async}}</span>
    <mat-chip-list #assetTypeChipList>
      <!-- Loop through the selectedAssetTypes and display each type as a chip -->
      <mat-chip *ngFor="let assetType of selectedAssetTypes" [selectable]="true" [removable]="true"
        (removed)="removeAssetType(assetType)">
        {{ assetType.Name }}
        <mat-icon matChipRemove>cancel</mat-icon>
      </mat-chip>

      <!-- Input field to filter and add Asset Types -->
      <input placeholder=" {{'Select Asset Type'| translate | async}}" #assetTypeInput [matAutocomplete]="autoAssetType"
        [matChipInputFor]="assetTypeChipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        [matChipInputAddOnBlur]="true" (input)="filterAssetTypes($event.target.value)" name="assetType"
        ngDefaultControl />
    </mat-chip-list>

    <!-- Auto-complete dropdown for available Asset Types -->
    <mat-autocomplete #autoAssetType="matAutocomplete" (optionSelected)="selectAssetType($event)">
      <mat-option *ngFor="let type of filteredAssetTypes" [value]="type">
        {{ type.Name }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>

  <mat-form-field class="header-form-full-width">
    <span class="label"> {{'Model'| translate | async}}</span>
    <mat-chip-list #modelChipList>
      <!-- Loop through the selected models and display each model as a chip -->
      <mat-chip *ngFor="let model of selectedModels" [selectable]="true" [removable]="true"
        (removed)="removeModel(model)">
        {{ model.Name }}
        <mat-icon matChipRemove>cancel</mat-icon>
      </mat-chip>

      <!-- Input field to filter and add Models -->
      <input placeholder="{{'Select Model'| translate | async}}" #modelInput [matAutocomplete]="autoModel"
        [matChipInputFor]="modelChipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        [matChipInputAddOnBlur]="true" (matChipInputTokenEnd)="addModel($event)"
        (input)="filterModels($event.target.value)" name="customer8" ngDefaultControl />
    </mat-chip-list>

    <!-- Auto-complete dropdown for available Models -->
    <mat-autocomplete #autoModel="matAutocomplete" (optionSelected)="selectModel($event)">
      <mat-option *ngFor="let model of filteredModels" [value]="model">
        {{ model.Name }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>

  <mat-form-field class="header-form-full-width">
    <span class="label"> {{'Asset Serial Number'| translate | async}}</span>
    <mat-chip-list #chipList1 aria-label="Asset Serial Number">
      <mat-chip *ngFor="let serial of selectedAssetSerials" [removable]="true" (removed)="removeAssetSerial(serial)">
        {{ serial.Name }}
        <button matChipRemove *ngIf="true">
          <mat-icon>cancel</mat-icon>
        </button>
      </mat-chip>
      <input placeholder="{{'Asset Serial Number'| translate | async}}" [matAutocomplete]="autoq" #assetSerialInput
        [matChipInputFor]="chipList1" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        (matChipInputTokenEnd)="addAssetSerial($event)" name="customer9" ngDefaultControl  (input)="filterAssetSerail($event.target.value)" />
    </mat-chip-list>
    <mat-autocomplete #autoq="matAutocomplete" (optionSelected)="selectAssetSerial($event)">
      <mat-option *ngFor="let asset of filteredAssetSerials" [value]="asset">
        {{ asset.Name }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>

  <mat-form-field class="header-form-full-width">
    <mat-chip-list #implementTypeChipList>
      <mat-chip *ngFor="let implementType of selectedImplementTypes" [selectable]="true" [removable]="true"
        (removed)="removeImplementType(implementType)">
        {{ implementType }}
        <mat-icon matChipRemove>cancel</mat-icon>
      </mat-chip>
      <input placeholder="Select Asset Definition" #implementTypeInput [matAutocomplete]="autoImplementType"
        [matChipInputFor]="implementTypeChipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        [matChipInputAddOnBlur]="true" (matChipInputTokenEnd)="addImplementType($event)"
        (input)="filterImplementTypes($event.target.value)" name="customer2" ngDefaultControl />
    </mat-chip-list>
    <mat-autocomplete #autoImplementType="matAutocomplete" (optionSelected)="selectImplementType($event)">
      <mat-option *ngFor="let implementType of filteredImplementTypes" [value]="implementType">
        {{ implementType.Name }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>


  <mat-form-field class="header-form-full-width">
    <span class="label"> {{'Serial Number'| translate | async}}</span>
    <mat-chip-list #serialChipList aria-label="Selected Serial Numbers">
      <mat-chip *ngFor="let chip of selectedEquipments" (removed)="removeEquipment(chip)">
        {{chip.SerialNumber}} : {{chip.UnitNumber}}
        <button matChipRemove>
          <mat-icon>cancel</mat-icon>
        </button>
      </mat-chip>

      <input placeholder="{{'Select Serial Number'| translate | async}}" #equipmentInput [matAutocomplete]="serialAuto"
        [matChipInputFor]="serialChipList" (matChipInputTokenEnd)="addEquipment($event)" name="customer13"
        (input)="filterEquipments($event.target.value)" ngDefaultControl>
    </mat-chip-list>
    <mat-autocomplete #serialAuto="matAutocomplete" (optionSelected)="selectEquipment($event)">
      <mat-option *ngFor="let equipment of filteredEquipmentList" [value]="equipment">
        {{equipment.SerialNumber}} : {{equipment.UnitNumber}}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>

  <mat-form-field *ngIf="showMultipleAssetAlt" class="header-form-full-width">
    <span class="label"> {{'Asset Alt. Number'| translate | async}}</span>
    <mat-select id="select-equipment-serialno" placeholder="{{'Asset Alt. Number'| translate | async}}"
      [(ngModel)]="selectedAssetALT" ngDefaultControl multiple>
      <mat-option [value]="alt.Id" *ngFor="let alt of AssetSerialALTList">
        {{alt.Name}}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <div class="bottom-row">
    <section class="evaluation-middle evaluation-middle-altered">
      <span> {{'Evaluation'| translate | async}}</span>
      <mat-checkbox [checked]="EvalA" (change)="getEvalA()" class="evaluation-check-a">
        A
      </mat-checkbox>
      <mat-checkbox [checked]="EvalB" (change)="getEvalB()" class="evaluation-check-b">
        B
      </mat-checkbox>
      <mat-checkbox [checked]="EvalC" (change)="getEvalC()" class="evaluation-check-c">
        C
      </mat-checkbox>
      <mat-checkbox [checked]="EvalX" (change)="getEvalX()" class="evaluation-check-x">
        X
      </mat-checkbox>
    </section>
    <div style="width: 30%;">
      <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group" [(ngModel)]="onEqS"
        name="OnEquipmentCondition" (change)="getOnEquipment()">
        <mat-radio-button class="example-radio-button" [value]="1">{{'On Equipment'| translate | async}}
        </mat-radio-button>
        <mat-radio-button class="example-radio-button" [value]="2"> {{'Inventory'| translate |
          async}}</mat-radio-button>
        <mat-radio-button class="example-radio-button" [value]="4"> {{'Template'| translate | async}}</mat-radio-button>
        <mat-radio-button class="example-radio-button" [value]="3" [checked]="true">{{'All'| translate |
          async}}</mat-radio-button>
      </mat-radio-group>
    </div>
    <div class="flex flex--align-center" style="width: 30%; justify-content: end !important;">
      <a class="button" (click)="ResetFields();"><span class="button__text">{{'Reset'| translate | async}}</span></a>
      <a class="button button--primary" (click)="submitSelection()">
        <i class="material-icons button__icon">search</i><span class="button__text">{{'Search'| translate |
          async}}</span>
      </a>
    </div>
  </div>
</div>